module.exports = __webpack_public_path__ + "static/img/15.f6c6735.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/15.png
// module id = mMLl
// module chunks = 0